import { Injectable } from "@angular/core"
import Apiresponse = require("../models/api-response");

@Injectable()
export class NotificationService
{
     isInfo: boolean;
     isWarning: boolean;
     isError: boolean;
     isSuccess: boolean;
     message: string;
     data: any;
     isDisplaying: boolean;

    constructor() {
        this.clear();
    }

    displayMessage(type: string, msg: string, data:any = null) {
        this.clear();
        this[type] = true;
        this.message = msg;
        if (this.IsJsonString(data)) {
            this.data = JSON.parse(data);
        }
        this.isDisplaying = true;
    }

    displayInfo(msg: string) {
        this.displayMessage("isInfo", msg);
    }

    displaySuccess(msg: string) {
        this.displayMessage("isSuccess", msg);
    }
    displayWarning(msg: string) {
        this.displayMessage("isWarning", msg);
    }
    displayError(msg: string) {
        this.displayMessage("isError", msg);
    }
    displayErrorWithJsonData(msg: string, data: any) {
        this.displayMessage("isError", msg, data);
    }

    displayApiResponseError(msg: Apiresponse.ApiResponse) {
        var errorMessage = "server error";
        if (msg.data.reasonPhrase) {
            errorMessage = msg.data.reasonPhrase;
        }
        else if (msg.statusCode === "403") {
            errorMessage = "Forbidden";
        }
        else if (msg.statusCode !== 0) {
            errorMessage = this.extractErrorMessage(msg.data);
        }
        this.displayMessage("isError", errorMessage, msg.data);
    }

    // msg.data can be a plain string or a JSON object body; avoid rendering "[object Object]"
    private extractErrorMessage(data: any): string {
        if (data == null) {
            return "server error";
        }
        if (typeof data === "string") {
            return data;
        }
        var candidate = data.message || data.reasonPhrase;
        if (typeof candidate === "string" && candidate.trim() !== "") {
            return candidate;
        }
        try {
            return JSON.stringify(data);
        } catch (e) {
            return "server error";
        }
    }

    clear() {
        this.isInfo = this.isError = this.isSuccess = this.isWarning = this.isDisplaying = false;
        this.message = "";
    }

    IsJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/services/notification.service.ts
 **/